/**
 * How many of the tier's pixels the frame renders over.
 *
 * It writes to [renderScaleMultiplier](../../../render/post/renderScaleMultiplier.ts), which the
 * running pipeline applies to the surface the moment it moves, so the drag itself shows what the
 * pixels are worth. The bounds and the default are that module's, on the terms the sensitivity
 * knob states.
 */

import {
  DEFAULT_RENDER_SCALE_MULTIPLIER,
  MAX_RENDER_SCALE_MULTIPLIER,
  MIN_RENDER_SCALE_MULTIPLIER,
  setRenderScaleMultiplier,
} from '@/render/post/renderScaleMultiplier';
import { rangeApply } from '@/ui/settings/controls/rangeSlider';
import { SETTING_RENDER_SCALE_HINT, SETTING_RENDER_SCALE_LABEL } from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

/** Five percent per stop: coarse enough to land on a value twice, fine enough to tune by eye. */
const STEP = 0.05;

export const RENDER_SCALE: SettingDefinition = {
  id: 'renderScale',
  section: 'video',
  label: SETTING_RENDER_SCALE_LABEL,
  hint: SETTING_RENDER_SCALE_HINT,
  control: {
    kind: 'range',
    min: MIN_RENDER_SCALE_MULTIPLIER,
    max: MAX_RENDER_SCALE_MULTIPLIER,
    step: STEP,
    format: (value: number): string => value.toFixed(2),
  },
  defaultValue: DEFAULT_RENDER_SCALE_MULTIPLIER,
  apply: rangeApply(setRenderScaleMultiplier),
};
